// extracted by mini-css-extract-plugin
module.exports = {"container":"invite-friend_container__8OcXa","text":"invite-friend_text___CUbx"};